import React from 'react';
import SEO from '../SEO/SEO';
import './Legal.scss';

function Legal() {
  return (
    <>
      <SEO 
        title="Mentions Légales | Judcoco"
        description="Mentions légales du site Judcoco, créatrice d'emotes personnalisées"
        pathname="/legal"
      />
      
      <div className="legal-container">
        <h1>Mentions Légales</h1>
        
        <section>
          <h2>Éditeur du site</h2>
          <p>Ce site est édité par Judcoco</p>
          {/* <p>Auto-entrepreneur</p> */}
          {/* <p>Adresse : [Votre adresse ou BP]</p> */}
          <p>Contact : judcoco19@gmail.com</p>
        </section>

        <section>
          <h2>Hébergement</h2>
          <p>Ce site est hébergé par Vercel Inc.</p>
          <p>340 S Lemon Ave #4133</p>
          <p>Walnut, CA 91789</p>
          <p>États-Unis</p>
        </section>

        <section>
          <h2>Propriété intellectuelle</h2>
          <p>L'ensemble des éléments de ce site (images, textes, logos...) sont protégés par le droit d'auteur. Toute reproduction sans autorisation préalable est interdite.</p>
        </section>

        <section>
          <h2>Protection des données</h2>
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant.</p>
        </section>
      </div>
    </>
  );
}

export default Legal;